<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{title}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="col">
        <p><b>{{ message }}</b></p>
    </div>
</div>
<div *ngIf="title === 'Confirm'" class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="close()">No</button>
    <button type="button" class="btn btn-primary" (click)="confirm();">Yes</button>
</div>